import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { ICON_STACK_CLASS_NAME } from '../../theme/constants/stack';

const SvgIconWrapper = React.forwardRef(({ Icon, sx, svgWrapperClassName, ...other }, ref) => (
  <Stack
    ref={ref}
    width="100%"
    display="flex"
    justifyContent="center"
    alignItems="center"
    {...other}
    className={[svgWrapperClassName, other.className].filter(Boolean).join(' ')}
  >
    <Box sx={sx}>
      <Icon style={{ width: '100%', height: '100%', display: 'block' }} />
    </Box>
  </Stack>
));

SvgIconWrapper.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  sx: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.func,
  ]),
  svgWrapperClassName: PropTypes.string,
};

SvgIconWrapper.defaultProps = {
  sx: {},
  svgWrapperClassName: ICON_STACK_CLASS_NAME,
};

export default SvgIconWrapper;
